export default __webpack_public_path__ + "static/media/snowMan.991e0695.gif";